export { default } from './FullInvPartSelector';
